// tslint:disable
export var ContactDatePreferenceType;
(function (ContactDatePreferenceType) {
    // UNKN
    ContactDatePreferenceType[ContactDatePreferenceType["UNKNOWN"] = 0] = "UNKNOWN";
    // DAY
    ContactDatePreferenceType[ContactDatePreferenceType["DAY"] = 1] = "DAY";
    // BTWDAY
    ContactDatePreferenceType[ContactDatePreferenceType["BETWEENDATES"] = 2] = "BETWEENDATES";
    // HOLDY
    ContactDatePreferenceType[ContactDatePreferenceType["HOLIDAY"] = 3] = "HOLIDAY";
    // WKEND
    ContactDatePreferenceType[ContactDatePreferenceType["WEEKENDS"] = 4] = "WEEKENDS";
    // WKDAY
    ContactDatePreferenceType[ContactDatePreferenceType["WEEKDAYS"] = 5] = "WEEKDAYS";
})(ContactDatePreferenceType || (ContactDatePreferenceType = {}));
//# sourceMappingURL=ContactDatePreferenceType.js.map